import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import images from '../../data/images.json';
import './ComingSoon.css';

const ComingSoon: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Set launch date (30 days from now)
  const launchDate = new Date();
  launchDate.setDate(launchDate.getDate() + 30);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = launchDate.getTime() - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      // Here you would typically send the email to your backend
      console.log('Email submitted:', email);
    }
  };

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="coming-soon-content">
            <div className="logo-section">
              <img
                src={images.logo}
                alt="Manjushree Foundation Logo"
                className="coming-soon-logo"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://via.placeholder.com/120x120/f4c430/333333?text=MF';
                }}
              />
              <h1 className="foundation-name">Manjushree Foundation</h1>
              <p className="foundation-tagline">Transforming Hearts, One Life at a Time</p>
            </div>

            <div className="main-message">
              <h2 className="coming-soon-title">We're Coming Soon!</h2>
              <p className="coming-soon-subtitle">
                We're working hard to bring you an amazing experience. 
                Our website is under development and will be launching soon.
              </p>
            </div>

            <div className="countdown-section">
              <h3 className="countdown-title">Launching In</h3>
              <div className="countdown-timer">
                <div className="countdown-item">
                  <div className="countdown-number">{timeLeft.days}</div>
                  <div className="countdown-label">Days</div>
                </div>
                <div className="countdown-separator">:</div>
                <div className="countdown-item">
                  <div className="countdown-number">{timeLeft.hours}</div>
                  <div className="countdown-label">Hours</div>
                </div>
                <div className="countdown-separator">:</div>
                <div className="countdown-item">
                  <div className="countdown-number">{timeLeft.minutes}</div>
                  <div className="countdown-label">Minutes</div>
                </div>
                <div className="countdown-separator">:</div>
                <div className="countdown-item">
                  <div className="countdown-number">{timeLeft.seconds}</div>
                  <div className="countdown-label">Seconds</div>
                </div>
              </div>
            </div>

            <div className="notify-section">
              <h3 className="notify-title">Get Notified When We Launch</h3>
              {!submitted ? (
                <form className="notify-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="email"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="email-input"
                      required
                    />
                    <button type="submit" className="notify-button">
                      Notify Me
                    </button>
                  </div>
                </form>
              ) : (
                <div className="success-message">
                  <span className="success-icon">✓</span>
                  <p>Thank you! We'll notify you when we launch.</p>
                </div>
              )}
            </div>

            <div className="contact-section">
              <h3 className="contact-title">Stay Connected</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="contact-icon">📧</span>
                  <a href="mailto:wenshungo@gmail.com">wenshungo@gmail.com</a>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <a href="tel:+919818334590">+91 98183 34590</a>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <span>Katorwa, Bodhgaya, Near Vietnam Temple, Sadar, Gaya, Bihar - 824231</span>
                </div>
              </div>
            </div>

            <div className="social-section">
              <p className="social-text">Follow us for updates</p>
              <div className="social-links">
                <a href="#" className="social-link" aria-label="Facebook">
                  <img src={images.social?.facebook || '/images/social/facebook.png'} alt="Facebook" />
                </a>
                <a href="#" className="social-link" aria-label="Instagram">
                  <img src={images.social?.instagram || '/images/social/instagram.png'} alt="Instagram" />
                </a>
                <a href="#" className="social-link" aria-label="Twitter">
                  <img src={images.social?.twitter || '/images/social/twitter.png'} alt="Twitter" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
